"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadDTO = void 0;
class UploadDTO {
    id;
    name;
    originalname;
    mimetype;
    hash;
    size;
    url;
    path;
    createdAt;
}
exports.UploadDTO = UploadDTO;
